module.exports = __webpack_public_path__ + "img/ios3.37de7d75.png";